// removed by extract-text-webpack-plugin
module.exports = {"container":"Header__container__ed0b4813"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/Header.scss
// module id = 1839
// module chunks = 7 16